export interface IFooterBlock {
  header: string;
  links?: {
    name: string;
    url: string;
    fontWeight: number;
    view: string;
    color?: string;
    icon?: string;
  }[];
  subHeaders?: IFooterBlock[];
}

export interface IDocumentLinks {
  title: string;
  url: string;
  customClass?: string;
}

export interface IPartnersLevels {
  [key: string]: {
    name: string;
    percent: number;
    color: string;
    description: string;
  }
}

export interface IReviews {
  description: string;
  name: string;
  position: string;
  photo: string;
  size: string;
}

export interface IGettings {
  header: string;
  description: string;
  color: string;
}

export interface IDocuments {
  format: string;
  title: string;
  link: string;
}

export interface IMenuLinks {
  route: string;
  name: string;
}

export const phoneNums = {
  salesDepartment: {
    formatted: '+998 (78) 113-66-61',
    value: '+998781136661'
  },
  partnerDepartment: {
    formatted: '+998 (78) 113-66-68',
    value: '+998781136668'
  }
}

export const getMenuLinks = (): IMenuLinks[] => {
  return [
    {
      route: '/',
      name: 'Главная'
    },
    {
      route: '/partners',
      name: 'Партнёрам'
    },
    {
      route: '/help',
      name: 'Помощь'
    },
    {
      route: '/price',
      name: 'Цена'
    }
  ]
}

export const getFooterBlocks = (): IFooterBlock[] => {
  return [
    {
      header: 'Контакты',
      subHeaders: [
        {
          header: 'Техподдержка',
          links: [
            {
              name: 'support@onlinepbx.uz',
              url: 'mailto:support@onlinepbx.uz',
              fontWeight: 400,
              view: ''
            },
            {
              name: '+998 (78) 113-26-50',
              url: 'tel:+998781132650',
              fontWeight: 400,
              view: ''
            },
            {
              name: 'telegram_bot',
              url: 'https://t.me/onpbxuz_bot',
              fontWeight: 400,
              view: '',
              color: '#0D71D7'
            }
          ]
        }
      ]
    },
    {
      header: '',
      subHeaders: [
        {
          header: 'Отдел продаж',
          links: [
            {
              name: 'go@onlinepbx.uz',
              url: 'mailto:go@onlinepbx.uz',
              fontWeight: 400,
              view: ''
            },
            {
              name: phoneNums.salesDepartment.formatted,
              url: `tel:${phoneNums.salesDepartment.value}`,
              fontWeight: 400,
              view: ''
            },
            {
              name: 'telegram_chat',
              url: 'https://t.me/onlinepbx_sales',
              fontWeight: 400,
              view: '',
              color: '#0D71D7'
            }
          ]
        }
      ]
    },
    {
      header: '',
      subHeaders: [
        {
          header: 'Партнерский отдел',
          links: [
            {
              name: 'partner@onlinepbx.uz',
              url: 'mailto:partner@onlinepbx.uz',
              fontWeight: 400,
              view: ''
            },
            {
              name: phoneNums.partnerDepartment.formatted,
              url: `tel:${phoneNums.partnerDepartment.value}`,
              fontWeight: 400,
              view: ''
            },
            {
              name: 'telegram_chat',
              url: 'https://t.me/onlinepbx_sales',
              fontWeight: 400,
              view: '',
              color: '#0D71D7'
            }
          ]
        }
      ]
    },
    {
      header: '',
      subHeaders: [
        {
          header: 'Социальные сети',
          links: [
            {
              name: 'Instagram',
              url: 'https://www.instagram.com/onlinepbx.uz/?hl=ru',
              fontWeight: 400,
              view: '',
              icon: 'InstaIcon'
            },
            {
              name: 'Telegram',
              url: 'https://t.me/onlinepbx_news',
              fontWeight: 400,
              view: '',
              icon: 'TelegramIcon'
            }
          ]
        }
      ]
    }
  ]
}

export const getDocumentLinks = (): IDocumentLinks[] => {
  return [
    {
      title: 'Лицензионный договор между ООО «Chukreev PBX» и  ООО «Тесла Телеком»',
      url: process.env.PUBLIC_DIR + '/privacy/contract.pdf',
      customClass: 'onlinepbx__footer__documents__link__block'
    },
    {
      title: 'Политика обработки персональных данных',
      url: process.env.PUBLIC_DIR + '/privacy/conf.pdf',
    },
    {
      title: 'Публичная оферта',
      url: process.env.PUBLIC_DIR + '/privacy/oferta_uz.pdf',
    }
  ]
}

export const dividedByThree = (num: number, addSymbol = ',') => {
  const parts = (num + '').split('.')
  const main = Array.from(parts[0]).reverse()
  const output = main.map((char, index) => (index + 1 !== main.length && (index + 1) % 3 === 0 ? addSymbol + char : char)).reverse().join('')
  return parts.length > 1 ? output + '.' + parts.slice(1).join('.') : output
}

export const getPartnersLevels = (): IPartnersLevels => {
  return {
    10: {
      percent: 10,
      name: 'Partner',
      color: 'rgba(0, 199, 159, 0.3)',
      description: '10 % от всех оплат приведённых клиентов в течение 2-х лет'
    },
    20: {
      percent: 20,
      name: 'Silver',
      color: 'linear-gradient(140.19deg, #B7B7B7 0%, rgba(255, 255, 255, 0) 100%), #EAE6E1',
      description: '20% от оплат клиентов, онлайн обучение и сертификат партнёра'
    },
    30: {
      percent: 30,
      name: 'Gold',
      color: 'linear-gradient(140.19deg, #C3BB95 0%, rgba(255, 255, 255, 0) 100%), #F8F1D1',
      description: '30% от всех оплат клиентов'
    }
  }
}

export const getReviews = (): IReviews[] => {
  return [
    {
      size: '18px',
      description:
        'C onlinepbx сотрудничаем уже много лет и за это время они зарекомендовали себя как стабильный сервис с широким функционалом, а так же показали профессионализм техподдержки в решении клиентских задач.',
      name: 'Алексей Петров,',
      position: 'руководитель компании',
      photo: process.env.PUBLIC_DIR + '/images/webregata-review.png'
    },
    {
      size: '14px',
      description:
        'Мы являемся не только партнёрами onlinePBX, но и сами используем её в ежедневной работе уже более 4 лет. Сервис показал себя стабильным, какие-либо сбои являются большой редкостью. Особенно радует адекватная техническая поддержка, которая способна решить абсолютно любую задачу. Сам сервис постоянно развивается и появляется что-то новое.',
      name: 'Константин Кузнецов,',
      position: 'генеральный директор',
      photo: process.env.PUBLIC_DIR + '/images/rocketsales-review.png'
    },
    {
      size: '18px',
      description:
        'Возможность подключения сразу нескольких внешних номеров позволяет использовать разные номера телефонов и разных операторов связи, настраивая логику внутри onlinepbx.',
      name: 'Хуршед Нурматов,',
      position: 'генеральный директор',
      photo: process.env.PUBLIC_DIR + '/images/loftylab-review.png'
    }
  ]
}

export const getGettings = (): IGettings[] => {
  return [
    {
      header: 'До 30% от оплат приведённых клиентов',
      description: 'Автоматическая генерация отчётов и ежемесячные выплаты',
      color: '#00C69E'
    },
    {
      header: 'Онлайн-обучение',
      description: 'Расскажем о возможностях сервиса и как его продавать',
      color: '#EFA5DF'
    },
    {
      header: 'Статистика по клиентам',
      description: 'В личном кабинете партнёра хранится информация по приведённым клиентам',
      color: '#FFC90C'
    }
  ]
}

export const getDocuments = (): IDocuments[] => {
  return [
    {
      format: 'PDF',
      title: 'Политика обработки персональных данных',
      link: process.env.PUBLIC_DIR + '/privacy/conf.pdf'
    },
    {
      format: 'PDF',
      title: 'Лицензионный договор в форме публичной оферты на использование программного продукта "onlinePBX".',
      link: process.env.PUBLIC_DIR + '/privacy/oferta_uz.pdf'
    },
    {
      format: 'PDF',
      title: 'Договор-оферта партнёрской программы',
      link: 'https://partners.onlinepbx.ru/files/oferta.pdf'
    },
    {
      format: 'PDF',
      title: 'Сводная ведомость результатов проведения специальной оценки условий труда',
      link: process.env.PUBLIC_DIR + '/privacy/regulations.pdf'
    }
  ]
}
